import type { AllRouteEndpoints } from "../routeTypes";
export const oauthAuthorizeCacheKeys: AllRouteEndpoints[] = [];
